import React from 'react';
import { ResponseError } from 'services/api/base';
import useFileDownloadApi from 'utils/hooks/useFileDownloadApi';
import ActionButton from 'components/ActionButton';
import DownloadErrorSnackbar from 'components/DownloadErrorSnackbar';

import './index.scss';

export default function DownloadButton<ParamsType>({
  blobDownloader,
  params,
  filename,
  tooltipText,
  className,
  disabled = false,
  id,
}: {
  blobDownloader: (params: ParamsType) => Promise<Blob | ResponseError>,
  params: ParamsType,
  filename: string,
  tooltipText: string,
  className?: string,
  disabled?: boolean,
  id?: string,
}) {
  const {
    isLoading,
    error,
    clearError,
    onClick,
  } = useFileDownloadApi({ blobDownloader, params, filename });

  return (
    <>
      <ActionButton
        id={id}
        loading={isLoading}
        onClick={onClick}
        tooltipText={tooltipText}
        className={`download-button ${className}`}
        icon="download"
        type="primary"
        small={false}
        disabled={disabled}
      />
      <DownloadErrorSnackbar message={error} onClose={clearError} />
    </>
  );
}
